import { TableRow } from "../../utils/tables-metadata";
import { RelatedPersonRowData } from "./related-person-rows";
import { BaseTableLayout } from "../../components/base-table-layout";

export type RelatedPersonTableProps = {
  rows: TableRow[];
  onRowClick: (row: TableRow) => void;
  filterQuery: string;
  onPdfView?: (docId: string) => void;
  displayName?: string;
};

export function RelatedPersonTable({
  rows,
  onRowClick,
  filterQuery,
  displayName = "Related Persons",
}: RelatedPersonTableProps) {
  function handleRowClick(row: TableRow) {
    onRowClick(row);
  }

  return (
    <BaseTableLayout
      title={displayName}
      rows={rows as unknown as RelatedPersonRowData[]}
      columns={[
        { key: "name", header: "Name" },
        { key: "relationships", header: "Relationships" },
        { key: "contacts", header: "Contacts" },
        { key: "addresses", header: "Addresses" },
      ]}
      filterQuery={filterQuery}
      onRowClick={handleRowClick}
    />
  );
}
